import React from 'react'

const ImgBlog = () => {
  return (
    <div>
     <div className="grid grid-cols-1 md:grid-cols-5 overflow-hidden">
        <img
          src="https://preetheme.com/html/bhouse/assets/img/instagram/1.jpg"
          alt="1"
          className=" object-cover object-center transition-transform duration-300 ease-in-out transform hover:scale-110"
        />
        <img
          src="https://preetheme.com/html/bhouse/assets/img/instagram/2.jpg"
          alt="2"
          className=" object-cover object-center transition-transform duration-300 ease-in-out transform hover:scale-110"
        />
        <img
          src="https://preetheme.com/html/bhouse/assets/img/instagram/4.jpg"
          alt="3"
          className=" object-cover object-center transition-transform duration-300 ease-in-out transform hover:scale-110"
        />
        <img
          src="https://preetheme.com/html/bhouse/assets/img/instagram/5.jpg"
          alt="4"
          className=" object-cover object-center transition-transform duration-300 ease-in-out transform hover:scale-110"
        />
        <img
          src="https://preetheme.com/html/bhouse/assets/img/instagram/6.jpg"
          alt="5"
          className=" object-cover object-center transition-transform duration-300 ease-in-out transform hover:scale-110"
        />
      </div>
    </div>
  )
}

export default ImgBlog
